<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Reports</h4>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="row"></div>
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table
                      class="table table-striped table-bordered dataTable"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="example_info">
                      <thead>
                        <tr role="row">
                          <th>Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody v-show="!loader">
                        <!-- <tr>
                          <td style="text-align: left">Female Registration</td>
                          <td>
                            <a
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="showReportPopup('F')"
                              >View</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left">Male Registration</td>
                          <td>
                            <a
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="showReportPopup('M')"
                              >View</a
                            >
                          </td>
                        </tr> -->
                        <tr>
                          <td style="text-align: left">Sales Report</td>
                          <td>
                            <a
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="showReportPopup()"
                              >View</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-center">
                    <div class="page-bottom-pagination text-right">
                      <Pagination
                        @page-change="pageChange"
                        @items-per-page-change="itemsPerPageChange"
                        ref="listPagination" />
                    </div>
                  </div>
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="text-center" style="margin-top: 20%" v-show="accessObject?.is_view == 0 || isShowAccessDeniedMessage">
          <h3>You do not have access to view admin</h3>
        </div> -->
      </div>
      <TextModal ref="textModal">
        <div class="modal-header">
          <h5 class="modal-title">Report</h5>
          <button
            type="button"
            class="close"
            v-on:click="$refs.textModal.closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Form ref="brandForm" @submit="downloadFile()">
          <div class="modal-body">
            <div class="form-group col-md-12">
              <label for="inputRole">Parameter</label>
              <span class="text-danger">*</span>
              <Field
                as="select"
                class="form-control"
                id="inputRole"
                name="parameter"
                v-model="detail.parameter"
                rules="required:parameter">
                <option value="" disabled>Select Parameter</option>
                <option value="DAILY">Daily</option>
                <option value="MONTHLY">Monthly</option>
                <option value="YEARLY">Yearly</option>
              </Field>
              <ErrorMessage name="parameter" class="text-danger" />
            </div>
            <div class="form-group col-md-12">
              <label for="inputRole">Gender</label>
              <!-- <span class="text-danger">*</span> -->
              <Field
                as="select"
                class="form-control"
                id="gender"
                name="gender"
                v-model="detail.gender">
                <option value="">Select gender</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
              </Field>
            </div>
            <div class="col-12 row" v-if="detail.parameter == 'DAILY'">
              <div class="col-md-6 form-group  ">
                <label>Form Date</label>
                <span class="text-danger">*</span>
                <Field
                  type="text"
                  name="from_date"
                  placeholder="From Date"
                  rules="required:From Date"
                  v-model="detail.from_date"
                  :validateOnInput="true"
                  v-slot="{ field }">
                  <Datepicker
                    v-bind="field"
                    autoApply
                    v-model="detail.from_date"
                    class="form-control p-0"
                    inputFormat="dd-MM-yyyy"
                    format="dd-MM-yyyy"
                    placeholder="From Date"
                    :clearable="false"
                    :max-date="detail.to_date"
                    style="background-color: white !important" />
                  <ErrorMessage name="from_date" class="text-danger" />
                </Field>
              </div>
              <div class="col-md-6 form-group">
                <label>To Date</label>
                <span class="text-danger">*</span>
                <Field
                  type="text"
                  name="to_date"
                  placeholder="To Date"
                  rules="required:To Date"
                  v-model="detail.to_date"
                  :validateOnInput="true"
                  v-slot="{ field }">
                  <Datepicker
                    v-bind="field"
                    autoApply
                    v-model="detail.to_date"
                    class="form-control p-0 ml-1"
                    inputFormat="dd-MM-yyyy"
                    format="dd-MM-yyyy"
                    placeholder="To Date"
                    :clearable="false"
                    :min-date="detail.from_date"
                    style="background-color: white !important" />
                  <ErrorMessage name="to_date" class="text-danger" />
                </Field>
              </div>
            </div>
            <div class="row ml-1">
              <div
                class="col-6 form-group"
                v-if="detail.parameter == 'MONTHLY'">
                <label>Select Month</label>
                <span class="text-danger">*</span>
                <Field
                  autoApply
                  type="text"
                  name="month"
                  class="form-control"
                  placeholder="Select Month"
                  v-model="detail.month"
                  v-slot="{ field }"
                  rules="required:month"
                  :validateOnInput="true">
                  <Datepicker
                    v-bind="field"
                    autoApply
                    v-model="detail.month"
                    inputFormat="MMM"
                    format="MMMM"
                    placeholder="Select Month"
                    style="background-color: white !important"
                    monthPicker>
                  </Datepicker>
                </Field>
                <ErrorMessage name="month" class="text-danger" />
                <!-- <datepicker name="month" v-model="detail.month" class="form-control" inputFormat="MMM" startingView="month"
                      placeholder="Select Month" minimumView="month" :clearable="false" rules="required:month"
                      style="background-color: white !important" /> -->
              </div>
              <div
                class="col-6 form-group"
                :class="detail.parameter == 'MONTHLY' ? 'col-6' : 'col-12'"
                v-if="
                  detail.parameter == 'MONTHLY' || detail.parameter == 'YEARLY'
                ">
                <label>Select Year</label>
                <span class="text-danger">*</span>
                <Field
                  type="text"
                  name="year"
                  class="form-control"
                  placeholder="Select Year"
                  v-model="detail.year"
                  v-slot="{ field }"
                  rules="required:year"
                  :validateOnInput="true">
                  <Datepicker
                    v-bind="field"
                    autoApply
                    v-model="detail.year"
                    inputFormat="MMM"
                    format="yyyy"
                    placeholder="Select Year"
                    style="background-color: white !important"
                    yearPicker>
                  </Datepicker>
                </Field>
                <ErrorMessage name="year" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="modal-footer pb-0">
            <div class="col-lg-12 col-sm-12 text-center mt-2">
              <button id="report-button" class="fill-btn px-4 ml-3">
                Generate Report
              </button>
            </div>
          </div>
        </Form>
      </TextModal>
    </div>
    <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";
import TextModal from "@/components/TextModal";
import moment from "moment";
import datepicker from "vue3-datepicker";
import Datepicker from "@vuepic/vue-datepicker";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  name: "Report",
  components: {
    Form,
    Field,
    ErrorMessage,
    ErrorComponent,
    DeleteModal,
    Pagination,
    TextModal,
    datepicker,
    Datepicker,
  },
  data() {
    return {
      // accessObject: this.$helperService.getAccessLevel("Manage staff"),
      loader: true,
      // isShowAccessDeniedMessage: false,
      searchObj: {
        keyword: "",
        gender: "",
      },
      detail: {
        parameter: "",
        from_date: "",
        to_date: "",
        month: null,
        year: null,
      },
      type: "",
      offset: -1,
      list: [],
      from_date: "",
      to_date: "",
      parameter: "",
    };
  },
  mounted() {
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = true;
    //   this.$router.push("/access-denied");
    //   return;
    // }

    this.$helperService.showMenu("true");
    this.getList(0);
  },
  methods: {
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            // this.$refs.errorComponent.setData(res, "No Report List Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    showReportPopup(type) {
      this.type = type;
      this.$refs.brandForm.resetForm();
      this.$refs.textModal.showModal();
    },
    resetForm() {
      this.$refs.brandForm.resetForm();
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.getList(0);
    },
    showDeletePopup(data) {
      this.$refs.deleteModal.showModal(
        "Delete Admin",
        "Are you sure you want to delete " + data.first_name,
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$api
        .deleteAPI({
          _action: "/delete/" + detail.uuid,
        })
        .then((res) => {
          if (res) {
            this.$refs.deleteModal.closeModal();
            this.getList();
            this.$notify({
              type: "success",
              text: res.message,
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
    downloadFile() {
      var url = "/report/sales";
      if (this.type == "F") {
        url = "/report/registration";
      } else if (this.type == "M") {
        url = "/report/registration";
      }
      if (this.type == "M" || this.type == "F") {
        url += "?type=" + this.type;
      }
      if (url == "/report/sales") {
        url += "?parameter=" + this.detail.parameter;
      }
      url += "&parameter=" + this.detail.parameter;
      if (this.detail.parameter == "DAILY") {
        url +=
          "&from_date=" +
          moment(this.detail.from_date).format("YYYY-MM-DD") +
          "&to_date=" +
          moment(this.detail.to_date).format("YYYY-MM-DD");
      } else if (this.detail.parameter == "MONTHLY") {
        url +=
          "&month=" +
          moment(this.detail.month).format("MM") +
          "&year=" +
          +this.detail.year;
      } else {
        url += "&year=" + this.detail.year;
      }
      if (this.detail.gender) {
        url += "&gender=" + this.detail.gender;
      }
      this.$refs.textModal.closeModal();
      url = this.$api.getBaseUrl() + url;
      window.open(url);
    },
  },
};
</script>
